// extracted by mini-css-extract-plugin
module.exports = {"title":"article-card_title__dQIK7","titletag":"article-card_titletag___YKut","read-more":"article-card_read-more__FuMCb","name":"article-card_name__oKbHa"};